export enum ChartLibrary {
    echarts = 'echarts',
    tradingView = 'trading_view',
    chartIq = 'chartiq'
}

export enum ChartTypes {
    candle = 'Candle Stick',
    line = 'Line',
    OHLC = 'OHLC',
    area = 'Area Chart'
}

export enum ChartUpdateType {
    new = 'new',
    update = 'update'
}
export enum ChartIntervals {
    '1m' = '1m',
    '5m' = '5m',
    '10m' = '10m',
    '15m' = '15m',
    '30m' = '30m',
    '1h' = '1h',
    '1d' = '1d',
    '1W' = '1w',
    'W' = '1w',
    '1M' = '1M',
    'M' = '1M'
}
